import { useEffect } from 'react';
import { isInteractiveElement } from '@bynder-studio/misc';
import { isCtrlKey } from 'packages/helpers/hotKeys';
import { useIsModalOpen } from '~/hooks/useIsModalOpen';

type Props = {
    changeToPrevious: () => void;
    changeToNext: () => void;
};

export default function useVariationsShortcuts({ changeToPrevious, changeToNext }: Props) {
    const isModalOpen = useIsModalOpen();

    const handleChange = (event) => {
        if (isInteractiveElement(event) || isCtrlKey(event) || isModalOpen) {
            return;
        }

        if (event.shiftKey) {
            if (['ArrowUp', 'PageUp', 'PgUp'].includes(event.code)) {
                event.preventDefault();

                if (changeToPrevious) {
                    changeToPrevious();
                }
            }

            if (['ArrowDown', 'PageDown', 'PgDn'].includes(event.code)) {
                event.preventDefault();

                if (changeToNext) {
                    changeToNext();
                }
            }
        }
    };

    useEffect(() => {
        document.addEventListener('keydown', handleChange);

        return () => {
            document.removeEventListener('keydown', handleChange);
        };
    }, [handleChange, isModalOpen]);
}
